"use client";

import { AlertCircle, Home, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";

interface ApiErrorPanelProps {
  message: string;
  className?: string;
  onTryAgain?: () => void;
  onGoHome?: () => void;
}

export function ApiErrorPanel({
  message,
  className,
  onTryAgain,
  onGoHome,
}: ApiErrorPanelProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center p-8 text-center",
        className
      )}
    >
      <AlertCircle className="w-12 h-12 text-red-500 mb-4" aria-hidden />
      <Text as="h2" size="xl" weight="semibold" color="default" className="mb-2">
      {message ? message : "Something went wrong"}
      </Text>
      <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
        {onTryAgain ? (
          <Button type="button" variant="outline" className="gap-2" onClick={onTryAgain}>
            <RefreshCw className="w-4 h-4" />
            Try again
          </Button>
        ) : null}
        {onGoHome ? (
          <Button type="button" variant="default" className="gap-2" onClick={onGoHome}>
            <Home className="w-4 h-4" />
            Go home
          </Button>
        ) : null}
      </div>
    </div>
  );
}
